import { useLoaderData, useRouteLoaderData } from "@remix-run/react";
import type { ActionFunction, LoaderFunction } from "@remix-run/server-runtime";
import { createSupabaseClient } from "~/supabase.server";
import type { InsertNotificationProperties } from "~/types/database.types";
import ManageNotifications from "~/components/settings/manageNotifications";
import { getNotificationProperties, upsertNotificationProperties } from "~/models/notificaitonProperties.server";

export const action: ActionFunction = async ({ params, request }) => {
  const supabase = createSupabaseClient(request, new Response());
  const { userId } = params;
  if (!userId) {
    throw new Error("No user id provided");
  }

  try {
    const body = await request.text();
    const { is_on, monthly_updates, insights, masleka_updates, announcements, push_enabled } = JSON.parse(body);

    const notificationProperties: InsertNotificationProperties = {
      user_id: userId,
      is_on,
      monthly_updates,
      insights,
      masleka_updates,
      announcements,
      push_enabled,
    }
    await upsertNotificationProperties(notificationProperties, supabase);
    return new Response(`success`, {status: 200});
  } catch (error: unknown) {
    return new Response(`fail`, {status: 204});
  }
}

export const loader: LoaderFunction = async ({ params, request }) => {
  const { userId } = params;
    if (!userId) {
    throw new Error("No user id provided");
  }
  const supabase  = createSupabaseClient(request, new Response());
  let data = await getNotificationProperties(supabase, userId);
  return {notificationProperties: data};
};

const NotificationProperties = () => {
  let { notificationProperties } = useLoaderData<{ notificationProperties: InsertNotificationProperties }>();
  let data = useRouteLoaderData("routes/notificationProperties/$userId");
  
  if (!notificationProperties) {
    notificationProperties = data?.notificationProperties;
  }

  return <ManageNotifications userNotificationProperties={notificationProperties} />;
};

export default NotificationProperties;
